// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"137bb809","845":"749da6c6"}[chunkId] + ".chunk.js";
};